import { render, staticRenderFns } from "./BonusCreditHistory.vue?vue&type=template&id=1a337d32&"
import script from "./BonusCreditHistory.vue?vue&type=script&lang=js&"
export * from "./BonusCreditHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports